import React from 'react'
import { FormControl, InputLabel, OutlinedInput } from '@mui/material'

const CustomOutlinedInput = ({ id, inputRef, label, width, value, onChange, type, style, onClick, onKeyDown, color }) => {
  return (
    <FormControl className="formcontrol" variant="outlined" size="small" sx={{ width: width || 'auto' }} style={style} color={color || "primary"}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <OutlinedInput id={id} inputRef={ inputRef } label={label} size="small" type={type} value={value} onClick={onClick} onChange={onChange} onKeyDown={onKeyDown} autoComplete="off" style={{backgroundColor:'#fff'}} />
    </FormControl>
  );
}

export default CustomOutlinedInput